import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from "../../../actions/api";
import PatientFormData from "./PatientFormData.js";

import { DeleteOutline, Edit } from "@mui/icons-material";
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { format, fromUnixTime, getUnixTime } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
//get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage")
);
const lan = localStorage.getItem("LangCode");
const menukey = "patients";
const LABTest_List = JSON.parse(localStorage.getItem("LABTest_List"));

const UserInfo = encryptionService.decryptUserInfo();
const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}
const EditPatient = (props) => {
  const permissionType = props.permissionType;
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    lastName: "",
    idNumber: "",
    registered: null,
    firstName: "",
    pass: "",
    deceased: null,
    knownName: "",
    ipn: "",
    transfferedIn: null,
    gender: "",
    OriginTypeId: "",
    dob: null,
    transferredOut: null,
    maritalStatus: "",
    active: "",
    PreEP: "",
    isArmy: "",
    InhIsPrevious: "",
    defaulter: null,
    languagePreference: "",
    ProtocolId: "",
    MmdId: "",
    ExistingProtocolId: "",
    ExistingMmdId: "",
    temporaryPatient: "",
    stopped: null,
    InhStartDate: null,
    InhEndDate: null,
    address: "",
    contactNumber: "",
    email: "",
    allergiesData: [],
    anthropometricsData: [],
    labResultsData: [],
    firstProtocolName: "",
    TransferFromFacilityId: "",
    TransferToFacilityId: "",
    TransferFromCountryId: "",
    TransferToCountryId: "",
    PatientcoinfectionId: "",
    KeypopulationTypeId: "",
    CohortId: "",
  });

  const [allergyData, setAllergyData] = useState({
    id: null,
    date: null,
    allergyTitle: null,
    description: null,
    source: null,
  });

  const [anthropometricData, setAnthropometricData] = useState({
    id: null,
    date: null,
    weight: null,
    height: null,
    bmi: null,
    bsa: null,
  });

  const [labResultData, setLabResultData] = useState({
    id: null,
    testCode: null,
    testName: null,
    testResult: null,
    testDate: null,
    LocationId: null,
  });

  const [openAllergyDialog, setAllergyDialog] = useState(false);
  const [openAnthropometricDialog, setAnthropometricDialog] = useState(false);
  const [openLabResultDialog, setLabResultDialog] = useState(false);
  const [patientsPrescriptions, setPatientsPrescriptions] = useState([]);

  const [errorObject, setErrorObject] = useState({});
  const [errorAllergiesData, setErrorAllergiesObject] = useState({});
  const [errorAnthropometricsData, setErrorAnthropometricsObject] = useState(
    {}
  );
  const [errorLabResultsData, setErrorLabResultsObject] = useState({});
  const [PatientId, setPatientId] = useState(0);

  const [tabValue, setTabValue] = useState(0);
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery(
    ["patient", id],
    () =>
      api.getPatient(id).then((res) => {

        setPatientId(id);
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const prescriptionData = useQuery(
    ["prescriptions", id],
    () => api.getPrescriptionByPatientId(id),
    {
      onSuccess: (data) => {
        setPatientsPrescriptions(data);
      },
    }
  );

  const { isLoading, mutate } = useMutation(api.updatePatient, {
    onSuccess: (data) => {
      if (data.status == 200) {
        if (data.data.success == 1) {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });

          queryClient.setQueriesData(["patient", formData.id], data);
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
        //   props.history.push('/patients');
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const { isLoading1, mutate: AlergySave } = useMutation(
    api.SaveUpdateAallergies,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          //  let route = `${data.data.PatientId}`;
          // let route = `/patients/edit/${data.data.PatientId}`;
          // props.history.push(route);

          //let route = `/patients/edit/${data.data.PatientId}`;
          //props.history.push(route);

          //swal("Success!", "", "success");
          // props.history.push(route);

          if (data.data.success == 1) {
            formData["allergiesData"] = data.data.list.allergiesData;
            formData["allergiesData1"] = data.data.list.allergiesData;
            queryClient.setQueriesData(
              ["patient", formData.id],
              data.data.list
            );

            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          }
        }
      },
    }
  );
  const { mutate: deleteAlergies } = useMutation(api.deleteAlergies, {
    onSuccess: (data) => {
      //queryClient.setQueriesData(['patient', formData.id], data);

      if (data.status == 200) {
        if (data.data.success == 1) {
          queryClient.setQueriesData(["patient", formData.id], data.data.list);

          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      }
    },
  });

  const { mutate: getCD4WeightChart } = useMutation(api.getCD4WeightChart, {
    onSuccess: (data) => {},
  });

  const { mutate: AnthropometricSave } = useMutation(
    api.SaveUpdateAnthropometrics,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          // formData['anthropometricsData']=data.data.anthropometricsData;
          // formData['anthropometricsData1']=data.data.anthropometricsData;

          // queryClient.setQueriesData(['patient', formData.id], data);

          // props.openNoticeModal({
          //   isOpen: true,
          //   msg: data.message,
          //   msgtype: data.success,
          // });

          if (data.data.success == 1) {
            formData["anthropometricsData"] =
              data.data.list.anthropometricsData;
            formData["anthropometricsData"] =
              data.data.list.anthropometricsData;
            queryClient.setQueriesData(
              ["patient", formData.id],
              data.data.list
            );

            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          }
        }
      },
    }
  );
  const { mutate: deleteAnthropometric } = useMutation(
    api.deleteAnthropometrics,
    {
      onSuccess: (data) => {
        //queryClient.setQueriesData(['patient', formData.id], data);

        if (data.status == 200) {
          if (data.data.success == 1) {
            queryClient.setQueriesData(
              ["patient", formData.id],
              data.data.list
            );

            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          }
        }
      },
    }
  );

  const { mutate: SaveUpdateLabresults } = useMutation(
    api.SaveUpdateLabresults,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          // formData['labResultsData']=data.data.labResultsData;
          // formData['labResultsData1']=data.data.labResultsData;

          // queryClient.setQueriesData(['patient', formData.id], data);

          if (data.data.success == 1) {
            formData["labResultsData"] = data.data.list.labResultsData;
            formData["labResultsData"] = data.data.list.labResultsData;
            queryClient.setQueriesData(
              ["patient", formData.id],
              data.data.list
            );

            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
          }
        }
      },
    }
  );
  const { mutate: deleteLabresults } = useMutation(api.deleteLabresults, {
    onSuccess: (data) => {
      //queryClient.setQueriesData(['patient', formData.id], data);

      if (data.status == 200) {
        if (data.data.success == 1) {
          queryClient.setQueriesData(["patient", formData.id], data.data.list);

          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;

    if (name === "OriginTypeId") {
      // Convert the value to a number before setting it in the state
      data[name] = parseInt(value, 10);
       
      data["TransferFromFacilityId"] = "";
      data["TransferToFacilityId"] = "";
      data["TransferFromCountryId"] = "";
      data["TransferToCountryId"] = "";
    }

    if (name == "idNumber") {
      const uppercaseValue = e.target.value.toUpperCase();
      data["idNumber"] = uppercaseValue;
    }

    setFormData(data);
    //setFormData({ ...formData, [name]: value });
    setErrorObject({ ...errorObject, [name]: null });
  };

  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    data[name] = value;
    setFormData(data);
    setErrorObject({ ...errorObject, [name]: "" });
  };
  //====== End Choosen Dropdown===========

  const handleCheck = (e) => {
    const { name, checked } = e.target;

    let data = { ...formData };
    data[name] = checked;

    if (name === "PreEP") {
      if (checked === true) {
        data["active"] = false;
      }
    }

    if (name === "active") {
      if (checked === true) {
        data["temporaryPatient"] = false;
      }
    }

    if (name === "temporaryPatient") {
      if (checked === true) {
        data["active"] = false;
      }
    }

    setFormData(data);

    //setFormData({ ...formData, [name]: checked });
  };

  const handleCheckPreEP = (e) => {
    const { name, checked } = e.target;

    let bDispenseVal = checked;

    let data = { ...formData };
    data[name] = checked;

    if (bDispenseVal == true) {
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey]["Do you want to patient PreEP!"]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          if (name === "PreEP") {
            if (checked === true) {
              data["active"] = false;
            }
          }
          setFormData(data);
          //setFormData({ ...formData, [name]: checked });
        } else {
          //refetch();
        }
      });
    } else {
      setFormData({ ...formData, [name]: checked });
    }
  };

  const handleCheckisArmy = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
   
  };

  function tabChangeHandler(event, newValue) {
    setTabValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const handleRDateChange = (date, field) => {
    let data = { ...formData };
    data[field] = date;

    if (
      field === "deceased" ||
      field === "stopped" ||
      field === "transferredOut" ||
      field === "defaulter"
    ) {
      if (date !== "") {
        data["active"] = false;
      }
    }

    if (field === "transfferedIn") {
      if (date !== "") {
        data["TransferFromFacilityId"] = "";
        data["TransferFromCountryId"] = "";
      }
    }
    if (field === "transferredOut") {
      if (date !== "") {
        data["TransferToFacilityId"] = "";
        data["TransferToCountryId"] = "";
      }
    }

    let newDate;
    if(date==null){
     newDate=date;
    }else{
      newDate = format(new Date(date), 'yyyy-MM-dd');
    } 

    data[field] = newDate;

    setFormData(data);

    // setFormData({ ...formData, [field]: date });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleReset = () => {
    setFormData({
      lastName: "",
      idNumber: "",
      registered: null,
      firstName: "",
      pass: "",
      deceased: null,
      knownName: "",
      ipn: "",
      transfferedIn: null,
      gender: "",
      OriginTypeId: "",
      dob: null,
      transferredOut: null,
      maritalStatus: "",
      active: "",
      PreEP: "",
      isArmy: "",
      InhIsPrevious: "",
      defaulter: null,
      languagePreference: "",
      ProtocolId: "",
      MmdId: "",
      ExistingProtocolId: "",
      ExistingMmdId: "",
      temporaryPatient: "",
      stopped: null,
      InhStartDate: null,
      InhEndDate: null,
      address: "",
      contactNumber: "",
      email: "",
      allergiesData: [],
      anthropometricsData: [],
      labResultsData: [],
      firstProtocolName: "",
      TransferFromFacilityId: "",
      TransferToFacilityId: "",
      TransferFromCountryId: "",
      TransferToCountryId: "",
      PatientcoinfectionId: "",
      KeypopulationTypeId: "",
      CohortId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["idNumber", "dob", "registered", "gender"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {

      if (formData["OriginTypeId"] === 1) {
        if (formData["transfferedIn"] != null) {
          if (formData["TransferFromFacilityId"] == "") {
            errorData["TransferFromFacilityId"] =
              DispensingLanguage[lan][menukey]["field is Required !"];
            isValid = false;
          }
        }

        if (formData["transferredOut"] != null) {
          if (formData["TransferToFacilityId"] == "") {
            errorData["TransferToFacilityId"] =
              DispensingLanguage[lan][menukey]["field is Required !"];
            isValid = false;
          }
        }
    }else{
      if (formData["transfferedIn"] != null) {
        if (formData["TransferFromCountryId"] == "") {
          errorData["TransferFromCountryId"] =
            DispensingLanguage[lan][menukey]["field is Required !"];
          isValid = false;
        }
      }

      if (formData["transferredOut"] != null) {
        if (formData["TransferToCountryId"] == "") {
          errorData["TransferToCountryId"] =
            DispensingLanguage[lan][menukey]["field is Required !"];
          isValid = false;
        }
      }
    }

      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const validateAllergiesForm = (allergyData) => {
    let validateFields = ["date", "allergyTitle"];
    let errorAllergiesData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!allergyData[field]) {
        errorAllergiesData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorAllergiesObject(errorAllergiesData);
    return isValid;
  };

  const validateAnthropometricsForm = (anthropometricData) => {
    let validateFields = ["date", "weight", "height"];
    let errorAnthropometricsData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!anthropometricData[field]) {
        errorAnthropometricsData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorAnthropometricsObject(errorAnthropometricsData);
    return isValid;
  };

  const validateLabResultsForm = (labResultData) => {
    let validateFields = ["testDate", "testCode"];
    let errorLabResultsData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!labResultData[field]) {
        errorLabResultsData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorLabResultsObject(errorLabResultsData);
    return isValid;
  };

  // const handleUpdate = () => {
  //   if (validateForm(formData)) {
  //     mutate(formData);

  //   }
  // };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
      //mutate(formData);
    }
  };

  // Tabs
  function ActionBtnAllergy(props: any) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";
    if (permissionType) {
      return <></>;
    } else {
      return (
        <>
          <Edit
            onClick={() => {
              editTabRecord(rowData, props.tabName);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deleteTabRecord(rowData, props.tabName);
            }}
          />
        </>
      );
    }
  }

  function DateFormater(props: any) {
    const rowData = props.cell._cell.row.data;
    let date = new Date();
    switch (props.tabName) {
      case "labResultsData":
        date = rowData.testDate;
        break;
      case "anthropometricsData":
        date = rowData.date;
        break;
      case "allergiesData":
        date = rowData.date;
        break;
      case "AppointmentDate":
        date = rowData.AppointmentDate;
        break;
      case "PostDate":
        date = rowData.PostDate;
        break;

      default:
        date = rowData.date;
        break;
    }
    return <>{date ? format(new Date(date), 'dd/MM/yyyy') : ""}</>;
  }

  function PostedCheckBox(props: any) {
    const rowData = props.cell._cell.row.data;
    return (
      <>
        <input type="checkbox" checked={rowData.status == "Posted"} />
      </>
    );
  }

  const editTabRecord = (data, tabName) => {
    switch (tabName) {
      case "allergiesData":
        setAllergyDialog(true);
        setAllergyData(data);
        setErrorAllergiesObject({});
        break;
      case "anthropometricsData":
        setAnthropometricDialog(true);
        setAnthropometricData(data);
        setErrorAnthropometricsObject({});
        break;
      case "labResultsData":
        setLabResultDialog(true);
        setLabResultData(data);
        setErrorLabResultsObject({});
        break;

      default:
        break;
    }
  };

  const deleteTabRecord = (data, tabName) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Record!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        switch (tabName) {
          case "allergiesData":
            formData[tabName] = formData[tabName].filter(
              (record) => record.id != data.AllergiesId
            );
            if (validateForm(formData)) {
              deleteAlergies(data.AllergiesId);
            }
            break;

          case "anthropometricsData":
            formData[tabName] = formData[tabName].filter(
              (record) => record.id != data.anthropometricsId
            );
            if (validateForm(formData)) {
              deleteAnthropometric(data.anthropometricsId);

              // mutate(formData);
              // swal("Success!", "", "success");
            }
            break;

          case "labResultsData":
            formData[tabName] = formData[tabName].filter(
              (record) => record.id != data.labtestdetailId
            );
            if (validateForm(formData)) {
              deleteLabresults(data.labtestdetailId);
              // mutate(formData);
              // swal("Success!", "", "success");
            }
            break;

          default:
            break;
        }
      }
    });
  };

  const calculateWeightCD4Count = () => {
    //getCD4WeightChart(PatientId);

    //option linechart Weight CD4 Count
    let data = { ...formData };
    let anthropometricsDataArray = data.anthropometricsData || [];
    let allergiesDataArray = data.allergiesData || [];
    let labResultsDataArray = data.labResultsData || [];
    let newdateList = [];
    let newdateList1 = [];
    let dateList = [];
    let list = [];
    let weightList = [];
    let cd4CountList = [];
    // if (anthropometricsDataArray.length > 0 && labResultsDataArray.length > 0) {

    dateList = anthropometricsDataArray.map((a) =>
      format(new Date(a.date), 'MM/dd/yyyy')
    );
    labResultsDataArray.map((a) => {
      //if(a.testCode == "CD4"){
      if (a.IsCD4 === 1) {
        dateList.push(format(new Date(a.testDate), 'MM/dd/yyyy'));
      }
    });

    /*
      newdateList = anthropometricsDataArray.map((a) => new Date(new Date(a.date)).format('MM/DD/YYYY'));
      


      labResultsDataArray.map((a) =>{
        if(a.testCode == "CD4"){ 
          newdateList1.push(new Date(new Date(a.testDate)).format('MM/DD/YYYY'));
        }
      })
      
    function getArraysIntersection(a1,a2){
        return  a1.filter(function(n) { return a2.indexOf(n) !== -1;});
    }
    
    dateList=getArraysIntersection(newdateList1, newdateList);  

    */

    list = dateList.filter((c, index) => {
      return dateList.indexOf(c) === index;
    });
    list = list.sort((a, b) => new Date(a) - new Date(b));
    list = list.map((date) => format(new Date(date), 'dd/MM/yyyy'));

    list.map((xAxisDate) => {
      let weightvalue = 0;
      anthropometricsDataArray.map((anth) => {
        let anthropometricDate = format(new Date(anth.date), 'dd/MM/yyyy');
        if (xAxisDate == anthropometricDate) {
          weightvalue = parseFloat(anth.weight);
        }
      });
      weightList.push(weightvalue);
      let cd4Value = 0;
      labResultsDataArray.map((lab) => {
        let labResultDate = format(new Date(lab.testDate), 'dd/MM/yyyy');
        //if (lab.testCode == "CD4" && xAxisDate == labResultDate) {
        if (lab.IsCD4 === 1 && xAxisDate == labResultDate) {
          cd4Value = parseFloat(lab.testResult);
        }
      });
      cd4CountList.push(cd4Value);
    });
    // }

    let option_linechart_WeightCD4Count = {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      tooltip: {
        shared: true,
      },
      yAxis: [
        {
          min: 0,
          //max: 1400,
          labels: {
            format: "{value}cmm",
          },
          title: {
            text: "CD4",
          },
        },
        {
          min: 0,
          //max: 120,
          labels: {
            format: "{value}kg",
          },
          title: {
            text: "Weight",
          },
          opposite: true,
        },
      ],
      xAxis: {
        categories: list,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "CD4 Count",

          data: cd4CountList || [],
          color: "#b60024",
          tooltip: {
            valueSuffix: " cmm",
          },
        },
        {
          name: "Weight",
          yAxis: 1,
          data: weightList || [],
          color: "#6c6463",
          tooltip: {
            valueSuffix: " kg",
          },
        },
      ],
    };

    return option_linechart_WeightCD4Count;

    /************Scatter********************/

    //option linechart Weight CD4 Count

    /*
    let data = { ...formData }
    let anthropometricsDataArray = data.anthropometricsData || []
    let allergiesDataArray = data.allergiesData || []
    let labResultsDataArray = data.labResultsData || []
    let dateList = []
    let list = []
    let weightList = []
    let cd4CountList = []

    let labResultsData =[]
    let anthropometricsData =[]


    //if (anthropometricsDataArray.length > 0 && labResultsDataArray.length > 0) {
     
       

      
    
    labResultsDataArray.sort(function (a, b) {
      if (new Date(b.testdate) <new Date( a.testDate)) {
          return 1;
      }
      if (new Date(b.testdate) >new Date( a.testDate)) {
          return -1;
      }
      return 0;
  });
   
  
  anthropometricsDataArray.sort(function (a, b) {
    if (new Date(b.date) <new Date( a.date)) {
        return 1;
    }
    if (new Date(b.date) >new Date( a.date)) {
        return -1;
    }
    return 0;
});

    labResultsDataArray.map((a) =>{
        if(a.testCode == "CD4"){
         let datalist=[]; 
         
         datalist.push(getUnixTime(new Date(a.testDate))) ;
         datalist.push(parseFloat(a.testResult)); 
         labResultsData.push(datalist); 
        
         
        }
      })
       
     
      anthropometricsDataArray.map((anth) =>{
        
         let datalistAnth=[]; 
         datalistAnth.push(getUnixTime(new Date(anth.date))) ;
         datalistAnth.push(parseFloat(anth.weight)); 
         anthropometricsData.push(datalistAnth); 
         
      })
      


      dateList = anthropometricsDataArray.map((a) => format(new Date(a.date), 'MM/dd/yyyy'))
      labResultsDataArray.map((a) =>{
        if(a.testCode == "CD4"){
          dateList.push(format(new Date(a.testDate), 'MM/dd/yyyy'));
        }
      })
      list = dateList.filter((c, index) => {
        return dateList.indexOf(c) === index;
      });
      list = list.sort((a, b) => new Date(a) - new Date(b));
      list = list.map((date) => getUnixTime(new Date(date)))
   

    let option_linechart_WeightCD4Count = {
      chart: {
       // type: "line",
       type: 'scatter',
      zoomType: 'xy'
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: "",
        },
      },
      xAxis: {
        title: {
          text: "Date",
        },
        // type: 'category',
        // categories: list, 
        // labels:
        // {
        //     enabled: false
        // }

        type: "datetime",
        startOnTick: true,
        startOnTick: true,
             endOnTick: true,
             showLastLabel: true,
             labels: {
                 formatter: function (obj) {
                   console.log('i: ',obj);

                     return  obj.isFirst? format(fromUnixTime(this.value), 'dd/MM/yyyy'):
                     (obj.isLast? format(fromUnixTime(this.value), 'dd/MM/yyyy'): 
                     format(fromUnixTime(this.value), 'dd/MM'));;
                 }
             }
        
      },
      credits: {
        enabled: false,
      },

      tooltip: {
        formatter: function () {
            return this.series.name+': ' + this.y +
                '<br>Date: ' + format(fromUnixTime(this.x), 'dd/MM/yyyy');
        }
     },
     plotOptions: {
      scatter: {
          marker: {
              radius: 10,
              states: {
                  hover: {
                      enabled: true,
                      lineColor: 'rgb(100,100,100)'
                  }
              }
          },
          states: {
              hover: {
                  marker: {
                      enabled: false
                  }
              }
          },

      }
  },
      
      series: [
        {
          name: "Weight",
          data: anthropometricsData || [],
          color: "#6c6463",
        },
        {
          name: "CD4 Count",
          data:  labResultsData|| [],
          color: "#b60024",
        },
      ],

      // series: [
      //   {
      //     name: "Weight",
      //     data: [300, 300, 300],
      //     color: "#6c6463",
      //   },
      //   {
      //     name: "CD4 Count",
      //     data: [145, 258, 180],
      //     color: "#b60024",
      //   },
      // ]
    };

    return option_linechart_WeightCD4Count*/
  };

  const calculateViralLoad = () => {
    //option linechart Weight CD4 Count
    let data = { ...formData };
    let labResultsDataArray = data.labResultsData || [];
    let dateList = [];
    let list = [];
    let cd4CountList = [];
    if (labResultsDataArray.length > 0) {
      labResultsDataArray.map((a) => {
        //if(a.testCode == "VL"){
        if (a.IsVirale === 1) {
          dateList.push(format(new Date(a.testDate), 'MM/dd/yyyy'));
        }
      });
      list = dateList.filter((c, index) => {
        return dateList.indexOf(c) === index;
      });
      list = list.sort((a, b) => new Date(a) - new Date(b));
      list = list.map((date) => format(new Date(date), 'dd/MM/yyyy'));

      list.map((xAxisDate) => {
        let cd4Value = 0;
        labResultsDataArray.map((lab) => {
          let labResultDate = format(new Date(lab.testDate), 'dd/MM/yyyy');
          //if (lab.testCode == "VL" && xAxisDate == labResultDate) {
          if (lab.IsVirale === 1 && xAxisDate == labResultDate) {
            cd4Value = parseFloat(lab.testResult);
          }
        });
        cd4CountList.push(cd4Value);
      });
    }

    //option linechart Weight CD4 Count
    let option_linechart_ViralLoad = {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: "",
        },
      },
      xAxis: {
        categories: list, //  ["10-09-2021", "11-09-2021", "12-09-2021"],//
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Viral Load",
          data: cd4CountList || [],
          //  data: [150, 120, 130],
          color: "#b60024",
        },
      ],
    };

    return option_linechart_ViralLoad;
  };

  const allergyDataColumns = [
    // { title: 'Date', field: 'date' },
    {
      title: t(DispensingLanguage[lan][menukey]["Date"]),
      field: "date",
      formatter: reactFormatter(<DateFormater tabName="allergiesData" />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Allergy"]),
      field: "allergyTitle",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Description"]),
      field: "description",
    },
    { title: t(DispensingLanguage[lan][menukey]["Source"]), field: "source" },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      headerHozAlign: "center",
      width: 130,
      formatter: reactFormatter(<ActionBtnAllergy tabName="allergiesData" />),
    },
  ];

  const anthropometricDataColumns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Date"]),
      field: "date",
      formatter: reactFormatter(<DateFormater tabName="anthropometricsData" />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Weight in KG"]),
      field: "weight",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Height in CM"]),
      field: "height",
    },
    { title: t(DispensingLanguage[lan][menukey]["BMI"]), field: "bmi" },
    { title: t(DispensingLanguage[lan][menukey]["BSA"]), field: "bsa" },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      headerHozAlign: "center",
      width: 130,
      formatter: reactFormatter(
        <ActionBtnAllergy tabName="anthropometricsData" />
      ),
    },
  ];

  const labResultsDataColumns = [
    /* { 
      title: t(DispensingLanguage[lan][menukey]['Test Code']) , 
      field: 'testCode' 
    }, */
    {
      title: t(DispensingLanguage[lan][menukey]["Test Date"]),
      field: "testDate",
      formatter: reactFormatter(<DateFormater tabName="labResultsData" />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Test Name"]),
      field: "testName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Test Result"]),
      field: "testResult",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Place"]),
      field: "LocationName",
    },
    /* { 
      title:  DispensingLanguage[lan][menukey]['Actions'] , 
      field: 'custom', 
      hozAlign: "center", 
      headerHozAlign: "center", 
      width: 130,
      formatter: reactFormatter(<ActionBtnAllergy tabName="labResultsData" />) 
    }, */
  ];

  var PostedIcon = function (cell, formatterParams) {
    const CellValue = cell._cell.row.data;
    if (CellValue.status == 1) {
      return "<i class='fa fa-check' style='color:green'></i>";
    } else {
      return "<i class='fa fa-times' style='color:red'></i>";
    }
  };

  const prescriptionDataColumns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Appointment Date"]),
      field: "AppointmentDate",
      width: 200,
      formatter: reactFormatter(<DateFormater tabName="AppointmentDate" />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["RxNumber"]),
      field: "prescriptionNumbar",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Prescriber"]),
      field: "prescriber",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Posted"]),
      // field: "posted",
      // formatter: reactFormatter(<PostedCheckBox />)
      field: "status",
      width: 100,
      formatter: PostedIcon,
      headerHozAlign: "center",
      hozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Post Date"]),
      field: "PostDate",
      width: 200,
      formatter: reactFormatter(<DateFormater tabName="PostDate" />),
    },

    /* {
      title: t(DispensingLanguage[lan][menukey]['Cost (CFA)']),
      field: "cost",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 180,
    }, */
  ];

  const generateIds = () => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const handleClickOpen = (tabName) => {
    switch (tabName) {
      case "allergiesData":
        setAllergyDialog(true);
        break;
      case "anthropometricsData":
        setAnthropometricDialog(true);
        break;
      case "labResultsData":
        setLabResultDialog(true);
        break;

      default:
        break;
    }
  };

  const handleClose = () => {
    setAllergyDialog(false);
    setAnthropometricDialog(false);
    setLabResultDialog(false);

    setAllergyData({
      id: null,
      date: null,
      allergyTitle: null,
      description: null,
      source: null,
    });
    setAnthropometricData({
      id: null,
      date: null,
      weight: null,
      height: null,
      bmi: null,
      bsa: null,
    });
    setLabResultData({
      id: null,
      testCode: null,
      testName: null,
      testResult: null,
      testDate: null,
      LocationId: null,
    });
  };

  const handleChangeByTabs = (e, tabName) => {
    const { name, value } = e.target;

    if (tabName == "allergyData") {
      setAllergyData({
        ...allergyData,
        [name]: value,
      });
      setErrorAllergiesObject({});
    }
    if (tabName == "anthropometricsData") {
      setAnthropometricData({
        ...anthropometricData,
        [name]: value,
      });
      setErrorAnthropometricsObject({});
    }
    if (tabName == "labResultsData") {
      setLabResultData({
        ...labResultData,
        [name]: value,
      });
      setErrorLabResultsObject({});
    }
  };

  const handleRDateChangeByTabs = (date, field, tabName) => {
    if (tabName == "allergyData") {
      setAllergyData({ ...allergyData, [field]: date });
      setErrorAllergiesObject({});
    }
    if (tabName == "anthropometricsData") {
      setAnthropometricData({ ...anthropometricData, [field]: date });
      setErrorAnthropometricsObject({});
    }
    if (tabName == "labResultsData") {
      setLabResultData({ ...labResultData, [field]: date });
      setErrorLabResultsObject({});
    }
  };

  const handleSubmitByTabs = (tabName) => {
    if (tabName == "allergyData") {
      let updateRecord = false;
      if (
        allergyData.id &&
        formData.allergiesData &&
        formData.allergiesData.find((record) => record.id == allergyData.id)
      ) {
        updateRecord = true;
      }
      if (allergyData.date == null) {
        allergyData.date = new Date();
      }
      if (validateAllergiesForm(allergyData)) {
        if (updateRecord) {
          formData["allergiesData"] = formData["allergiesData"].map(
            (record) => {
              if (record.id == allergyData.id) {
                record = allergyData;
              }
              return record;
            }
          );
          formData["allergiesData1"] = allergyData;
        } else {
          allergyData["id"] = generateIds();
          allergyData["patientId"] = formData.PatientId;

          formData["allergiesData"] =
            formData["allergiesData"].concat(allergyData);
          formData["allergiesData1"] = allergyData;
        }

        setAllergyData({
          id: null,
          date: null,
          allergyTitle: null,
          description: null,
          source: null,
        });
        setAllergyDialog(false);

        if (validateForm(formData)) {
          AlergySave(formData);
        }
      }
    }

    if (tabName == "anthropometricsData") {
      let updateRecord = false;
      if (
        anthropometricData.id &&
        formData.anthropometricsData &&
        formData.anthropometricsData.find(
          (record) => record.anthropometricsId == anthropometricData.id
        )
      ) {
        updateRecord = true;
      }
      if (anthropometricData.date == null) {
        anthropometricData.date = new Date();
      }
      if (anthropometricData.height && anthropometricData.weight) {
        //BMI
        let weight = parseFloat(anthropometricData.weight);
        let height = parseFloat(anthropometricData.height);
        anthropometricData.bmi = Number(
          (weight / Math.pow(height, 2)).toFixed(2)
        );

        //BSA
        anthropometricData.bsa = Number(
          0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425)
        ).toFixed(2);
      }
      if (validateAnthropometricsForm(anthropometricData)) {
        anthropometricData.weight = parseFloat(
          anthropometricData.weight
        ).toFixed(2);
        anthropometricData.height = parseFloat(
          anthropometricData.height
        ).toFixed(2);
        if (updateRecord) {
          formData["anthropometricsData"] = formData["anthropometricsData"].map(
            (record) => {
              if (record.id == anthropometricData.id) {
                record = anthropometricData;
              }
              return record;
            }
          );
          formData["anthropometricsData1"] = anthropometricData;
        } else {
          anthropometricData["id"] = generateIds();
          anthropometricData["patientId"] = formData.PatientId;
          formData["anthropometricsData"] =
            formData["anthropometricsData"].concat(anthropometricData);
          formData["anthropometricsData1"] = anthropometricData;
        }

        setAnthropometricData({
          id: null,
          date: null,
          weight: null,
          height: null,
          bmi: null,
          bsa: null,
        });
        setAnthropometricDialog(false);
        if (validateForm(formData)) {
          AnthropometricSave(formData);
          // mutate(formData);
          // swal("Success!", "", "success");
        }
      }
    }

    if (tabName == "labResultsData") {
      let updateRecord = false;
      if (labResultData.testCode) {
        let labTestNames = LABTest_List;
        let selectedTest = labTestNames.find(
          (test) => test.id == labResultData.testCode
        );
        if (selectedTest) {
          labResultData["testName"] = selectedTest.name;
          labResultData["testCode"] = selectedTest.id;
        }
      }
      if (labResultData.testDate == null) {
        labResultData.testDate = new Date();
      }
      if (
        labResultData.id &&
        formData.labResultsData &&
        formData.labResultsData.find(
          (record) => record.labtestdetailId == labResultData.id
        )
      ) {
        updateRecord = true;
      }
      if (validateLabResultsForm(labResultData)) {
        if (updateRecord) {
          formData["labResultsData"] = formData["labResultsData"].map(
            (record) => {
              if (record.id == labResultData.id) {
                record = labResultData;
              }
              return record;
            }
          );
          formData["labResultsData1"] = labResultData;
        } else {
          labResultData["id"] = generateIds();
          labResultData["patientId"] = formData.PatientId;
          formData["labResultsData"] =
            formData["labResultsData"].concat(labResultData);
          formData["labResultsData1"] = labResultData;
        }

        setLabResultData({
          id: null,
          testCode: null,
          testName: null,
          testResult: null,
          testDate: null,
          LocationId: null,
        });
        setLabResultDialog(false);
        if (validateForm(formData)) {
          SaveUpdateLabresults(formData);
        }
      }
    }
  };

  return (
    <>
      <PatientFormData
        tabValue={tabValue}
        errorObject={errorObject}
        handleRDateChange={handleRDateChange}
        handleChangeIndex={handleChangeIndex}
        tabChangeHandler={tabChangeHandler}
        addPatientForm={false}
        formData={formData}
        handleChange={handleChange}
        handleChangeChoosenProps={handleChangeChoosenProps}
        handleCheck={handleCheck}
        handleCheckPreEP={handleCheckPreEP}
        handleCheckisArmy={handleCheckisArmy}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        handleChangeByTabs={handleChangeByTabs}
        allergyData={allergyData}
        handleSubmitByTabs={handleSubmitByTabs}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        openAllergyDialog={openAllergyDialog}
        handleRDateChangeByTabs={handleRDateChangeByTabs}
        allergyDataColumns={allergyDataColumns}
        anthropometricDataColumns={anthropometricDataColumns}
        openAnthropometricDialog={openAnthropometricDialog}
        anthropometricData={anthropometricData}
        labResultsDataColumns={labResultsDataColumns}
        setLabResultDialog={setLabResultDialog}
        labResultData={labResultData}
        openLabResultDialog={openLabResultDialog}
        errorAllergiesData={errorAllergiesData}
        errorAnthropometricsData={errorAnthropometricsData}
        errorLabResultsData={errorLabResultsData}
        patientsPrescriptions={patientsPrescriptions}
        prescriptionDataColumns={prescriptionDataColumns}
        calculateWeightCD4Count={calculateWeightCD4Count}
        calculateViralLoad={calculateViralLoad}
        {...props}
      />
    </>
  );
};

export default EditPatient;
